import { useNavigate, useParams } from 'react-router-dom';
import { Anchor, Group, Stack, Text, Title } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { DataPanel } from '../../components/DataPanel';
import { VisitDetailPanel } from '../../components/detail/VisitDetailPanel';

/** Full-page visit detail — the route form of the old side drawer. */
export function VisitDetailPage() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { visitId = '' } = useParams<{ visitId: string }>();

    return (
        <Stack gap="lg">
            <Anchor
                component="button"
                type="button"
                c="dimmed"
                fz="sm"
                fw={600}
                onClick={() => navigate('/visits')}
                style={{ alignSelf: 'flex-start' }}
            >
                <Group gap={6}>
                    <IconArrowLeft size={15} />
                    {t('common.actions.back')}
                </Group>
            </Anchor>

            <Stack gap={2}>
                <Title order={2}>{t('detail.visit')}</Title>
                <Text size="sm" c="dimmed">
                    {visitId}
                </Text>
            </Stack>

            <DataPanel>{visitId ? <VisitDetailPanel visitId={visitId} /> : null}</DataPanel>
        </Stack>
    );
}
